'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import { filterObjectArrayBasedOnObjectArray, transformToLatin } from '../Utils/helpers.js';

function getOptions(options, keywords, fieldSearch, selectedItems, fieldKey) {
    return __awaiter(this, void 0, void 0, function () {
        var selectedItemIds, filtedContainOptions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof options === 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, options({
                            keywords: keywords
                        })];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    selectedItemIds = selectedItems.map(function (item) { return item[fieldKey]; });
                    filtedContainOptions = filterObjectArrayBasedOnObjectArray(options, selectedItems, fieldKey);
                    options.filter(function (option) { return !selectedItemIds.includes(option[fieldKey]); });
                    if (filtedContainOptions.length === 0) {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/, filtedContainOptions.filter(function (option) {
                            if (keywords === '') {
                                return true;
                            }
                            return transformToLatin(option[fieldSearch]).indexOf(keywords) > -1;
                        })];
            }
        });
    });
}

export { getOptions };
//# sourceMappingURL=helper.js.map
